<app-loading *ngIf="!contentReady"></app-loading>

<div class="skills-page container-fluid" dir="rtl" *ngIf="contentReady">
  <div class="page-card">

    <!-- Header -->
    <div class="skills-header">
      <div>
        <h2>إضافة مهارة جديدة</h2>
        <p>إدارة المهارات المستخدمة في الوظائف والتصنيفات المختلفة</p>
      </div>
    </div>

    <!-- Form -->
    <form class="skill-form-card" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="form-grid">

        <div class="form-item">
          <label>اسم المهارة بالإنجليزي</label>
          <input
            type="text"
            formControlName="name_en"
            placeholder="Example: JavaScript"
            [class.is-invalid]="data.get('name_en')?.invalid && data.get('name_en')?.touched"
          />
        </div>

        <div class="form-item">
          <label>اسم المهارة بالعربي</label>
          <input
            type="text"
            formControlName="name_ar"
            placeholder="مثال: جافا سكريبت"
            [class.is-invalid]="data.get('name_ar')?.invalid && data.get('name_ar')?.touched"
          />
        </div>

        <div class="form-item">
          <label>المختصر بالإنجليزي</label>
          <input
            type="text"
            formControlName="slug_en"
            placeholder="اختياري"
          />
        </div>

        <div class="form-item">
          <label>المختصر بالعربي</label>
          <input
            type="text"
            formControlName="slug_ar"
            placeholder="اختياري"
          />
        </div>

        <div class="form-item">
          <label>التصنيف</label>
          <select
            formControlName="category"
            [class.is-invalid]="data.get('category')?.invalid && data.get('category')?.touched"
          >
            <option value="">اختر التصنيف</option>
            <option value="education">تعليم</option>
            <option value="experience">خبرة</option>
            <option value="certificate">شهادة</option>
            <option value="language">لغة</option>
            <option value="technical">مهارة تقنية</option>
            <option value="soft_skill">مهارة شخصية</option>
            <option value="other">أخرى</option>
          </select>
        </div>

        <div class="form-actions">
          <button
            type="submit"
            class="main-btn"
            [disabled]="data.invalid || isSubmitting"
          >
            @if(isSubmitting){
              جاري الحفظ...
            }
            @else{
              + إضافة المهارة
            }
          </button>
        </div>

      </div>
    </form>

    <!-- Table -->
    <div class="skills-table-card">
      <div class="table-head">
        <div>
          <h3>قائمة المهارات</h3>
          <p>كل المهارات المضافة حاليًا داخل النظام</p>
        </div>
      </div>

      <div class="table-wrapper" *ngIf="skills.length > 0">
        <table class="skills-table">
          <thead>
            <tr>
              <th>#</th>
              <th>الاسم بالإنجليزي</th>
              <th>الاسم بالعربي</th>
              <th>التصنيف</th>
              <th>المختصر بالإنجليزي</th>
              <th>المختصر بالعربي</th>
              <th>الإجراء</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let skill of skills; let i = index">
              <td>{{ i + 1 }}</td>

              <td>
                <strong>{{ skill.name_en || '-' }}</strong>
              </td>

              <td>
                <strong>{{ skill.name_ar || '-' }}</strong>
              </td>

              <td>
                <span class="category-badge">
                  {{ getCategoryName(skill.category) }}
                </span>
              </td>

              <td>{{ skill.slug_en || '-' }}</td>

              <td>{{ skill.slug_ar || '-' }}</td>

              <td>
                <button
                  class="delete-btn"
                  type="button"
                  (click)="deleteSkill(skill.id)"
                >
                  حذف
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="empty-box" *ngIf="skills.length === 0">
        لا توجد مهارات حاليًا
      </div>
    </div>

  </div>
</div>